'use client';

import { useIsAuthenticating } from '@wwe-portal/web/providers/stores/auth-store';
import { useGetConsolidatedOffers } from '@wwe-portal/web/providers/queries/offer';
import { useStepupOfferAvailability } from './use-stepup-offer';
import { useStoreVirtualizedData } from './use-store-virtualized-data';
import { useMemo } from 'react';
import { buildOfferMaps } from '@wwe-portal/web/utils/offer/build-offer-maps';

export const useStoreData = () => {
  const currentUserLoading = useIsAuthenticating();

  const { data: consolidatedData, isLoading: isConsolidatedLoading } =
    useGetConsolidatedOffers();

  const flagshipOffers = useMemo(() => {
    return (
      consolidatedData?.special?.flatMap((section) => section.offers) || []
    );
  }, [consolidatedData]);

  const { offerMap, categoryMap } = useMemo(
    () => buildOfferMaps(consolidatedData),
    [consolidatedData]
  );

  const {
    isLoadingData: isLoadingStepupData,
    availability,
    stepupInfo,
  } = useStepupOfferAvailability();

  const resourceLoading =
    isConsolidatedLoading || isLoadingStepupData || currentUserLoading;
  const virtualizationEnabled = !resourceLoading;

  const virtualizeResult = useStoreVirtualizedData({
    categories: consolidatedData,
    stepupAvailable: availability,
    stepupInfo,
  });

  const isLoading = !virtualizationEnabled;

  return {
    virtualData: {
      rows: virtualizeResult.rows ?? [],
      categoryIndexes: virtualizeResult.categoryIndexes ?? {},
      estimatedSizes: [],
    },
    flagshipOffers,
    offerMap,
    categoryMap,
    isLoading,
  };
};
